export default {
   "Search": "Search",
   "Modules": "Modules",
   "Users": "Users",
   "Email": "Email",
   "Phone Number": "Phone Number",
   "Address": "Address",
   "Company login": "Company login",
  /***************** Sidebar *********/
    "Dashboard": "Dashboard",
 /****************** Navbar *************/
    "Logout": "Logout",
    "Profile": "Profile",
    "Invoices":"Invoices",
 /****************** Dashboard Datatable ***********/
   "Title": "Title",
   "Version": "Version",
   "Module Slug": "Module Slug",
   "Progress": "Progress",
   "Attempted on": "Attempted on",
   "Score":"Score",
   "Your Quizes":"Your Quizes",
   "Your Modules": "Your Modules",
   "Launch":"Launch",
   "Jump To Quiz": "Jump To Quiz",
   "Rows per page": "Rows per page",
 /****************** Users ***********/
    "Name": "Name",
    "Actions": "Actions",
    "Image" : "Image",
    "Salutation": "Salutation",
    "Invite Users": "Invite Users",
    "Date of Birth": "Date of Birth",
    "All cards": "All cards",
    "Card added successfully":"Card added successfully",
    "Remove" :"Remove",
    "User Profile": "User Profile",
    "All Cards": "All Cards",
    "Add Card" : "ADD CARD",
    "Primary": "Primary",
    "Are you sure want to remove?": "Are you sure want to remove?",
    "Subscribe" : "Subscribe",
    "Are you sure you want to purchase?": "Are you sure you want to purchase?",
    "Yes":"Yes",
    "No":"No",
    "You dont seem to have a card added to your profile":"You dont seem to have a card added to your profile",
    "Go to profile": "Go to profile",
    "Place of birth": "Place of birth",
 /****************** Courses ***********/
    "Filters":"Filters",
    "Details": "Details",
    "Purchased": "Purchased",
    "Included" : "Included",
    "What Will you Learn?": "What Will you Learn?",
    "Requirements" : "Requirements",
    "Description" : "Description",
    "PLAY NOW": "PLAY NOW",
    'Language': "Language",
    "Contact us": "Contact us",
    "Module": "Module",
    "Subject": "Subject",
    "Body": "Body",
    "Send copy to myself" : "Send copy to myself",
    "Status": "Status",
    "Join date": "Join date",
    "Change status": "Change status",
    "Active": "Active",
    "Inactive":"Inactive",
    "active": "Active",
    "inactive":"Inactive",
    "Pending": "pending",
    "disable": "disable",
    "pending": "Pending",
    "Subscribed":"Subscribed",
    "Unsubscribed":"Unsubscribed",
    "English":"English",
    "German":"German",
    "User updated successfully": "User updated successfully",
    "User created successfully": "User created successfully",
    "Learning material": "Learning material",
    'No modules found': 'No modules found',
    'Course': 'Course',
    'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
    'Your attempted modules': 'Your attempted modules',
    'No data found': 'No data found',
    'Search learning material': 'Search learning material',
    'Time Spent' : 'Time Spent',
    'From': 'From',
    'To': 'To',
    'Play':'Play',
    'Your sessions': 'Your sessions',
    'Your attempts': 'Your attempts',
    'Inbox': 'Inbox',
    'Settings': 'Settings',
    'View': 'View',
    'Roles': 'Roles',
    'Group': 'Groups',
    'Comment (optional)': 'Comment (optional)',
    'Due date':'Due date',
    'Select file': 'Select file',
    'User document name':'User document name',
    'Days until': 'Days until',
    'Template' : 'Template',
    'Update': 'Update',    
    'Edit': 'Edit',
    'Uploaded by': 'Uploaded by',
    'Uploaded on': 'Uploaded on',
    'Type':'Type',
    'Action':'Action',
    'Stage 1': 'Stage 1',
    'Stage 2': 'Stage 2',
    'Set Name': 'Set Name',
    'Show next': 'Show next',
    'Show from':'Show from',
    'Name is required': 'Name is required',
    'Invalid Email address': 'Invalid Email address',
    'Phone Number is required': 'Phone Number is required',
    'Salutation is required':'Salutation is required',
    'Address is required': 'Address is required',
    'Group admin is required':'Group admin is required',
    'Groups are required': 'Groups are required',
    'Status is required': 'Status is required',
    'Date is required': 'Date is required',
    'Mr': 'Mr',
    'Mrs':'Mrs',
    'Create learning material':'Create learning material',
    'Set Filter':'Set Filter',
    'Location':'Location',
    'Procedure': 'Procedure',
    'Class':'Class',
    'Maker':'Maker',
    'Serial maker': 'Serial maker',
    'Stock':'Stock',
    'Good until date': 'Good until date',
    'Equipment':'Equipment',
    'Number in stock': 'Number in stock',
    'Serial number':'Serial number',
    'Location is required':'Location is required',
    'Class is required':'Class is required',
    'Maker is required': 'Maker is required',
    'Number in stock is required':'Number in stock is required',
    'Goods until date is required': 'Goods until date is required',
    'Serial number is required':'Serial number is required',
    'Procedure is required':'Procedure is required',
    'Description is required':'Description is required',
    'Equipment created successfully':'Equipment created successfully',
    'Equipment updated successfully':'Equipment updated successfully',
    'Group name': 'Group name',
    'Group admins': 'Group admins',
    'Group name is required':'Group name is required',
    'Users are required': 'Users are required',
    'Course are required':'Course are required',
    'Learning material are required':'Learning material are required',
    'Company settings': 'Company settings',
    'Company Color': 'Company Color',
    'Session login time': 'Session login time',
    'Primary color is required':'Primary color is required',
    'Company settings updated successfully':'Company settings updated successfully',
    'Intellectual Property Rights': 'Intellectual Property Rights',
    'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.',
    'I accept this (required)': 'I accept this (required)',
    'Please subscribe to a course':'Please subscribe to a course',
    'Your score': 'Your score',
    'Max Score' : 'Max Score',
    'Time taken':'Time taken',
    'Pass Score':'Pass Score',
    'Confirm password': 'Confirm password',
    'No subscribed courses found':'No subscribed courses found',
    'Role is required':'Role is required',
    'Confirm Password is required': 'Confirm Password is required',
    'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character': 'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character',
    'Password must be at least 8 characters long': 'Password must be at least 8 characters long',
    'Confirm Password must be at least 8 characters long' : 'Confirm Password must be at least 8 characters long',
    'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character': 'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character',
    'Query successfully sent': 'Query successfully sent',
    "Learning Center": "Learning Center",
    "Courses": "Courses",
    "Check":"Check",
    "Clear": "Clear",
    'No data available': 'No data available',
    'Company color': 'Company color',
    'Update Password': 'Update Password',
    'This password reset token is invalid': 'This password reset token is invalid',
    'Password is required':'Password is required',
    'Accept & Continue':'Accept & Continue',
    'Due days is required':'Due days is required',
    'Learn NDT': 'Learn NDT',
    'Username': 'Username',
    'Password': 'Password',
    'Forgot password': 'Forgot password',
    'Register':'Register',
    'Login':'Login',
    'Username is required': 'Username is required',
    'Phone is required':'Phone is required',
    'User registeration successfully':'User registeration successfully',
    'Company Admin Login': 'Company Admin Login',
    'Go to Login': 'Go to Login',
    'Send link':'Send link',
    'No user documents':'No user documents',
    'User documents':'User documents',
    'Update user documents' : 'Update user documents',
    'Edit user documents': 'Edit user documents',
    'Module details': 'Module details',
    'passed':'Passed',
    'Passed':'Passed',
    'attempted': 'Attempted',
    'Attempted': 'Attempted',
    'Progress & Attempts': 'Progress & Attempts',
    'failed':'Failed',
    'of': 'of',
    'Details new': 'Details',
    'Passwords must match':'Passwords must match',
    'Save': 'Save',
    'Profile updated successfully': 'Profile updated successfully',
    'Group created successfully': 'Group created successfully',
    'Group updated successfully': 'Group updated successfully',
    'User document updated successfully': 'User document updated successfully',
    'Registration status changed successfully': 'Registration status changed successfully',
    'Write to Company Representative': 'Write to Company Representative',
    'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here': 'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here',
    'No Learning material found':'No Learning material found',
    'OK':'OK',
    'Cancel': 'Cancel',
    'Body is required':'Body is required',
    'Subject is required':'Subject is required',
    'Undefined':'Undefined',
    'Copyright legal notice':'Copyright legal notice',
    'Close':'Close',
    'Please upload a file':'Please upload a file',
    'The value must be an integer number':'The value must be an integer number',
    'Session minutes is required':'Session minutes is required',
    '& others':'& others',
    'Continue': 'Continue',
    'All':'All',
    'Reset your Password':'Reset your Password',
    'Group id': 'Group id',
    'Go to courses':'Go to courses',
    'Check all': 'Check all',
    'Uncheck all' : 'Uncheck all',
    'Not subscribed': 'Not subscribed',
    'Reset':'Reset',
    'dashboardstats': 'Showing {users} {userstat} and {courses} {coursesstat} '

  };